<template>
  <div class="navbar-with-back-button py-5 px-4 flex items-center sticky top-0 z-10 justify-center border-b border-neutral-200 lg:py-7 bg-white">
    <NuxtLink
      to="/"
      :aria-label="$t('Accessibilty.AriaLabels.GoToHomepage')"
      class="focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
    >
      <OSvg svg="logo" class="logo-width max-w-full text-black fill-current" />
    </NuxtLink>
    <button
      class="navbar-with-back-button-back-button py-3 pr-3 pl-1 absolute focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
      :aria-label="$t('Accessibilty.AriaLabels.GoBack')"
      @click="$emit('click')"
    >
      <OSvg svg="new-chevron-left" class="fill-neutral-800 w-4" />
    </button>
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'NavbarWithBackButton',
  components: {
    OSvg
  }
}
</script>

<style scoped lang="postcss">
.navbar-with-back-button {
  .logo-width {
    width: 14.6rem;
  }

  &-back-button {
    left: 1.8rem;
  }
}

@screen lg {
  .navbar-with-back-button {
    .logo-width {
      width: 20rem;
    }
  }
}
</style>
